

// Add to a shared utils file
export function sanitizeText(input, maxLength = 100) {
    if (!input) return '';
    
  // Strip HTML tags completely instead of encoding them
    // This removes <script>, <b>, etc. but keeps the text content
    let sanitized = input.replace(/<[^>]*>/g, '');
    
    // Also remove any dangerous characters that could break attributes
    // But keep normal text characters including &, quotes for readability
    sanitized = sanitized
        .replace(/javascript:/gi, '') // Remove javascript: protocol
        .replace(/on\w+\s*=/gi, ''); // Remove onclick=, onload=, etc.

    // Trim to max length if specified
    if (maxLength && sanitized.length > maxLength) {
        sanitized = sanitized.substring(0, maxLength);
    }
    
    return sanitized;
}